import * as React from "react";
export class StrikesBallsOuts extends React.PureComponent {
    render() {
        return (React.createElement("span", null,
            React.createElement("span", { className: "rj-baseball-scoreboard-balls" }, `${this.props.ballsTranslation}${this.props.balls}`),
            React.createElement("span", { className: "rj-baseball-scoreboard-strikes" }, `${this.props.strikesTranslation}${this.props.strikes}`),
            React.createElement("span", { className: "rj-baseball-scoreboard-outs" }, `${this.props.outsTranslation}${this.props.outs}`)));
    }
}
//# sourceMappingURL=StrikesBallsOuts.js.map